export enum ScreenFileUploadEnum {
    SALE = 'SALE',
    FINANCIAL_TRANSACTION_DEBIT = 'FINANCIAL_TRANSACTION_DEBIT',
}

export enum ScreenFileUploadLabelEnum {
    SALE = 'Venda',
    FINANCIAL_TRANSACTION_DEBIT = 'Despesa',
}
